export default __webpack_public_path__ + "static/media/icon_digitalAI.e90ab191.svg";